import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import {
  Backdrop,
  CircularProgress,
  Container,
} from "@mui/material";
import { getDataRequest, postDataRequest } from "../../helper/AxiosHelper";
import { validateForm } from "../../helper/FormHelper.jsx";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import FormContent from "../../components/organization/orgGrpFormSchema.jsx";
import OrgGrpForm from "../../components/organization/OrgGrpForm.jsx";

export default function Component() {
  const { org_id: orgId, id } = useParams();
  const navigate = useNavigate();
  const formik = useFormik(FormContent.FormikInstance);
  const [orgData, setOrgData] = useState({});
  const [record, setRecord] = useState(null);
  const [isDataPadding, setDataPadding] = useState(true);

  useEffect(() => {
    getDataRequest(`organization/show/${orgId}`, (isSuccess, data) => {
      if (!isSuccess) {
        return;
      }
      setOrgData(data.record || {});
    });
  }, [orgId]);

  useEffect(() => {
    getDataRequest(`orgGrp/show/${id}`, (isSuccess, data) => {
      if (!isSuccess || !data?.record) {
        setDataPadding(false);
        toast.error("找不到社別");
        return;
      }

      const loaded = data.record;
      if (String(loaded.org_id) !== String(orgId)) {
        setDataPadding(false);
        toast.error("找不到社別");
        navigate(`/organization/${orgId}/grps`);
        return;
      }

      const formFieldList = Object.keys(FormContent.FormikInstance.initialValues);
      formFieldList.forEach((field) => {
        formik.setFieldValue(field, loaded[field] ?? "");
      });
      setRecord(loaded);
      setDataPadding(false);
    });
  }, [id]);

  const handleUpdate = async () => {
    if (await validateForm(formik)) return;

    const payload = {
      org_id: Number(orgId),
      grp_code: formik.values.grp_code.trim(),
      name_zh: formik.values.name_zh.trim(),
      name_en: (formik.values.name_en || "").trim(),
      display_pos: Number(formik.values.display_pos),
    };

    postDataRequest(`orgGrp/update/${id}`, payload, (isSuccess) => {
      if (!isSuccess) {
        return toast.error("更新失敗");
      }
      toast.success("更新成功");
    });
  };

  return (
    <Container maxWidth={"lg"}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isDataPadding}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CommonBreadcrumb
        dbData={{
          organization_id: orgId,
          organization_name: orgData?.name_zh,
          id: record?.id,
          name_zh: record?.name_zh,
        }}
      />
      <OrgGrpForm formik={formik} submitLabel="更新" onSubmit={handleUpdate} />
    </Container>
  );
}
